import { render, staticRenderFns } from "./SsBackground.vue?vue&type=template&id=4221d97e"
import script from "./SsBackground.vue?vue&type=script&lang=js"
export * from "./SsBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports